export default __webpack_public_path__ + "static/media/ICA.58e80fa5.svg";